import { type QueryKey, useQueryClient } from "@tanstack/vue-query";

// This composable is used to handle query hydration on the client side
// after the server-side rendering has completed. It ensures that the
// query is "personalized" for users on the client.

// The reason we do this is because we don't have access to user data on the server side with our
// current cloudflare setup.
const useSuspenseWithHydration = <T extends () => Promise<any>>(params: {
  suspenseFn: T;
  queryKey: QueryKey;
}) => {
  const queryClient = useQueryClient();

  onServerPrefetch(async () => {
    await params.suspenseFn();
  });

  // When loaded on the server, we need to invalidate the query cache
  // so that the client refetches the data and follows are up-to-date.
  onBeforeMount(() => {
    queryClient.invalidateQueries({ queryKey: params.queryKey });
  });
};

export default useSuspenseWithHydration;
